<template>
	<div>
		<div class="list-group-item user-account-title p-l-30" style="padding: 20px 15px" @click="toggleExpand" :class="{ 'user-account-title-open': expanded }">
			<span :class="'fa ' + expandIcon" style="padding-right: 1em">
			</span>

			<span>
				{{ accountDisplay }}
			</span>

			<span class="pull-right">
				<button class="btn btn-info btn-bold">
					Show Subforms
				</button>

				<button class="btn btn-primary btn-bold" @click="goSharedInsights">
					Open Dashboard
				</button>
			</span>
		</div>
		<sharedinsights-download-form
			class="list-group-item"
			v-show="expanded"
			:account_nbr="account_nbr"
			:enrollments="enrollments"
		>
		</sharedinsights-download-form>
	</div>
</template>

<style scoped>
</style>

<script>
	export default {
		name: "sharedinsights-account-list-item",
		props: [
			'account_nbr',
			'account_nm',
			'city',
			'state_cd',
			'enrollments'
		],
		data: function () {
			return {
				expanded: false
			}
		},
		computed: {
			accountDisplay: function () {
				return "#" + this.account_nbr + " - " + this.account_nm + " (" + this.city + ", " + this.state_cd + ")";
			},
			shared_insights_url: () =>
				(window.location.hostname === 'mylab.midwestlabs.com' ?
					'https://sharedinsights.midwestlabs.com/index.html' : (
						window.location.hostname === 'mylabtest.midwestlabs.com' ?
							'https://sharedinsights-staging.midwestlabs.com/index.html' :
							'https://sharedinsights-dev.midwestlabs.com/index.html')),
			expandIcon: function () {
				return this.expanded ? 'fa-minus' : 'fa-plus';
			}
		},
		methods: {
			toggleExpand: function () {
				this.expanded = !this.expanded;
			},

			goSharedInsights: function () {
				window.open(
					'/account/feature/sso?feature_name=SHARED_INSIGHTS&account_nbr=' + this.account_nbr + '&redirect_url=' + this.shared_insights_url,
					'_blank'
				);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// sharedinsights-account-list-item.vue?6dfaa3ca